export default {
  // START:: GET APP LOCALE
  getAppLocale(state) {
    return state.perfermo_provider_dashboard_language;
  },
  // END:: GET APP LOCALE
};
